export const RECIPIENT_COPY_TAG_TOOLTIP_DETAIL =
  "signed copy of the disclosure package. It moves with the package and can't be edited or deleted.";

export const RECIPIENT_COPY_TAG_TOOLTIP = `A borrower's ${RECIPIENT_COPY_TAG_TOOLTIP_DETAIL}`;
